var React = require('react');

import Form from 'components/form';
import Checkbox from 'components/checkbox';
var Input = require('./../../input');
var InputDropdownToggle = require('./../../input_dropdown_toggle');
var SelectInput = require('./../../select_input');
var TextArea = require('./../../textarea');

class IncidentTemplateForm extends React.Component {
  static defaultProps = {
    components_label: 'Alert Users Subscribed To:',
    shouldTweet: false,
  };

  constructor(props) {
    super(props);
    this.state = {
      shouldTweet: this.props.should_tweet,
      shouldSendNotifications: this.props.should_send_notifications
    };
  }

  _showGroupDropdown() {
    if (this.props.allow_groups) {
      return (
        <InputDropdownToggle dropdownName="group_id"
                             inputName="group_name"
                             label="Incident Template Group"
                             helpBlockText="The group that this template belongs to."
                             placeholder="New Template Group Name"
                             toggleElement="create"
                             cancelText="Cancel new group creation"
                             options={this.props.group_values}
                             defaultValue={this.props.default_group}
                             selectClass="full-width"/>
      );
    } else {
      return <input type="hidden" id="nil_group_selector" name="group_id" value="no_group"/>;
    }
  }

  _showComponentSelector() {
    if (this.props.allow_components && this.props.components.length > 0) {
      return (
        <div className="component-subscriptions control-group">
          <label>{this.props.components_label}</label>
          <ItemsSelector items={ this.props.components }
                         className={ this.props.item_selector_class_name }
                         preselectedItemIds={ this.props.selected_components }
                         hiddenFieldName="component_ids"/>
        </div>
      );
    }
  }

  _showSendNotificationsCheckbox() {
    return (
      <div className="send-notifications-update control-group">
        <label>Send Notifications</label>
        <Checkbox name="should_send_notifications"
                  label="Checks the 'Send Notifications' checkbox when using this template"
                  defaultChecked={this.props.should_send_notifications}
                  onChange={this._handleSendNotificationsCheckboxChange} />
        <input type="hidden" id="should_send_notifications" name="should_send_notifications" value={!!this.state.shouldSendNotifications}/>
      </div>
    );
  }

  _showTwitterCheckbox() {
    // Checkboxes are shitty, and either return 'on' or nil.
    // Utilize a hidden input to send either true or false to the controller.
    if (this.props.allow_twitter && this.props.isTwitterAuthorized) {
      return (
        <div className="twitter-update control-group">
          <label>Tweet Update</label>
          <Checkbox name="should_tweet"
                    label="Check the 'Post to Twitter' checkbox when using this template"
                    defaultChecked={this.props.should_tweet}
                    onChange={this._handleTwitterCheckboxChange} />
          <input type="hidden" id="should_tweet" name="should_tweet" value={!!this.state.shouldTweet}/>
        </div>
      );
    } else {
      return <input type="hidden" id="should_tweet" name="should_tweet" value="false"/>;
    }
  }

  _handleTwitterCheckboxChange = (event) => {
    this.setState({shouldTweet: event.target.checked });
  }

  _handleSendNotificationsCheckboxChange = (event) => {
    this.setState({shouldSendNotifications: event.target.checked });
  }

  render() {
    return (
      <div className="incident-template-form">
        <Form for="IncidentTemplate" method={this.props.method} action={this.props.path}>
          { this._showGroupDropdown() }
          <Input type="text"
                 inputClass="full-width"
                 label="Template Name"
                 name="name"
                 placeholder="Template Name"
                 defaultValue={this.props.template ? this.props.template.name : null}
                 helpBlockText="This is used internally so you can identify which template you're using."/>

          <SelectInput name="update_status"
                 label="Incident Status"
                 options={this.props.status_values}
                 helpBlockText="The status that will be applied to the incident or scheduled maintenance."
                 defaultValue={this.props.template ? this.props.template.update_status : null}
                 selectClass="full-width"
                 groups={["Realtime Incidents", "Scheduled Maintenances"]} />

          <Input type="text"
                 inputClass="full-width"
                 label="Incident Title"
                 name="title"
                 placeholder="Incident Title"
                 defaultValue={this.props.template ? this.props.template.title : null}
                 helpBlockText="The title given to the incident or scheduled maintenance. This is only applied when creating an incident or scheduled maintenance."/>

          <div className="span12 text-area-container control-group">
              <TextArea inputClass="full-width"
                 label="Message Body"
                 name="body"
                 placeholder="Message Body"
                 defaultValue={ this.props.template ? this.props.template.body : null }
                 textareaStyle={{ height: 160 }}/>
          </div>
          { this._showComponentSelector() }
          { this._showTwitterCheckbox() }
          { this._showSendNotificationsCheckbox() }
          <div className="form-actions">
            <button type="submit" className="cpt-button style-primary size-small">{this.props.button_text} Template</button>
          </div>
        </Form>
      </div>
    );
  }
}

module.exports = IncidentTemplateForm;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/incident_templates/incident_template_form.jsx